<!--博物馆主题活动-详情(公用)-->
<template>
    <div class="museum-act-info-container" v-loading="loading">
        <!-- 顶部标题栏 -->
        <div class="museum-act-info-header">
            <div class="museum-act-header-placeholder"></div>
            <div class="museum-act-info-title" :title="activityForm.activityName">{{ activityForm.activityName || '活动详情' }}</div>
            <div class="museum-act-back-btn" @click="backPage">⇦返回</div>
        </div>

        <!-- 主内容区 -->
        <div class="museum-act-info-main">
            <!-- 左侧详情 -->
            <div class="museum-act-info-left">
                <!-- 活动信息 -->
                <div class="museum-act-info-row">
                    <span class="museum-act-info-label">活动主题：</span>
                    <span class="museum-act-info-value">{{ activityForm.activityName || '-' }}</span>
                </div>
                <div class="museum-act-info-row">
                    <span class="museum-act-info-label">所属主题：</span>
                    <span class="museum-act-info-value">{{ activityForm.activityItemName || '-' }}</span>
                </div>
                <div class="museum-act-info-row">
                    <span class="museum-act-info-label">学段年级：</span>
                    <span class="museum-act-info-value">{{ activityForm.periodName }}{{ activityForm.activityGradeName ? '·' + activityForm.activityGradeName : '' }}</span>
                </div>
                <div class="museum-act-info-row">
                    <span class="museum-act-info-label">活动时长：</span>
                    <span class="museum-act-info-value">{{ activityForm.activityTime || '-' }}</span>
                </div>

                <!-- 活动说明 -->
                <div class="museum-act-info-section" v-if="activityForm.activityDesc">
                    <div class="museum-act-section-label">活动说明：</div>
                    <div class="museum-act-info-content rich-content" v-html="activityForm.activityDesc"></div>
                </div>

                <!-- 活动目标 -->
                <div class="museum-act-info-section" v-if="activityForm.activityAim">
                    <div class="museum-act-section-label">活动目标：</div>
                    <div class="museum-act-info-content rich-content" v-html="activityForm.activityAim"></div>
                </div>

                <!-- 活动附件 -->
                <div class="museum-act-info-section">
                    <div class="museum-act-section-label">活动附件：</div>
                    <div class="museum-act-file-list" v-if="fileList && fileList.length > 0">
                        <div class="museum-act-file-item" v-for="(item, index) in fileList" :key="index">
                            <div class="museum-act-file-name">{{ item.fileName }}</div>
                            <div class="museum-act-file-actions">
                                <div class="museum-act-file-action" v-if="judgeIsPPT(item.fileType)" @click="viewPPTFile(item.fileUrl)" title="预览">
                                    <img src="@/assets/file/ppt_play.png" alt="预览"/>
                                </div>
                                <div class="museum-act-file-action" @click="handleDownload(item)" title="下载">
                                    <img src="@/assets/file/file_download.png" alt="下载"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="museum-act-no-file" v-else>暂无附件</div>
                </div>
            </div>

            <!-- 右侧封面 -->
            <div class="museum-act-info-right">
                <div class="museum-act-section-label">活动封面：</div>
                <div class="museum-act-cover">
                    <img :src="activityForm.activityCover" alt="活动封面"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {infoMuseumActivity} from "@/api/admin/museum";
import {downloadFile} from "@/api/adminservice/public";

export default {
    name: "museumActivityInfo",
    components: {},
    data() {
        return {
            loading:false,
            activityForm:{},
            fileList:[],
        }
    },
    computed: {},
    props:{
        activityId:{
            type: [String,Number],
            default:null
        },
        markInfo:{
            type: String,
            default:null
        },
    },
    watch: {
        markInfo(newValue,oldValue){
            this.queryActivityInfo();
        },
    },
    created() {
        this.queryActivityInfo();
    },
    mounted() {},
    methods: {
        /*查询活动详情*/
        queryActivityInfo() {
            if (!this.activityId) return;
            this.loading = true;
            infoMuseumActivity({ activityId: this.activityId }).then(res => {
                if (res.data.code === 1) {
                    this.activityForm = res.data.data || {};
                    this.fileList = this.activityForm.fileList || [];
                } else {
                    this.$message.error(res.data.msg || "请求出错");
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },
        /*文件操作*/
        judgeIsPPT(fileType) {
            if (!fileType) return false;
            return fileType.toLowerCase().includes("ppt");
        },
        viewPPTFile(fileUrl) {
            const openUrl = "https://ow365.cn/?i=36735&ssl=1&furl=" + fileUrl;
            window.open(openUrl, "_blank");
        },
        handleDownload(item) {
            downloadFile(item.fileUrl, item.fileName);
        },
        backPage(){
            this.$emit('back-page');
        }
    }
}
</script>

<style scoped>
.museum-act-info-container{
    width: 100%;
    height: 100%;
    padding: 10px 30px 20px 30px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}

/* 顶部标题栏 */
.museum-act-info-header{
    flex-shrink: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
}
.museum-act-back-btn{
    flex-shrink: 0;
    height: 32px;
    padding: 0 14px;
    background: #ff7f2e;
    color: #fff;
    line-height: 32px;
    text-align: center;
    font-size: 14px;
    border-radius: 6px;
    cursor: pointer;
    white-space: nowrap;
}
.museum-act-info-title{
    flex: 1;
    min-width: 0;
    text-align: center;
    font-size: 18px;
    color: #ff7f2e;
    font-weight: bold;
    letter-spacing: 1px;
    padding: 0 20px;
    box-sizing: border-box;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.museum-act-header-placeholder{
    width: 80px;
    flex-shrink: 0;
}

/* 主内容区 */
.museum-act-info-main{
    flex: 1;
    min-height: 0;
    width: 100%;
    display: flex;
    gap: 30px;
    overflow: hidden;
}
.museum-act-info-left{
    flex: 1;
    min-width: 0;
    height: 100%;
    overflow-y: auto;
    padding-right: 10px;
    box-sizing: border-box;
}
.museum-act-info-right{
    width: 260px;
    height: 100%;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-sizing: border-box;
}
.museum-act-info-left::-webkit-scrollbar,
.museum-act-info-right::-webkit-scrollbar{
    width: 6px;
}
.museum-act-info-left::-webkit-scrollbar-thumb,
.museum-act-info-right::-webkit-scrollbar-thumb{
    background: #d1d5db;
    border-radius: 3px;
}

/* 通用标签与内容 */
.museum-act-section-label,
.museum-act-info-label{
    font-size: 15px;
    color: #ff7f2e;
    font-weight: bold;
    flex-shrink: 0;
}
.museum-act-info-row{
    display: flex;
    align-items: baseline;
    font-size: 14px;
    line-height: 2;
}
.museum-act-info-label{
    margin-right: 6px;
}
.museum-act-info-value{
    color: #1f2937;
}
.museum-act-info-section{
    margin-top: 16px;
}
.museum-act-info-content{
    font-size: 14px;
    color: #374151;
    line-height: 1.8;
    text-align: justify;
    padding-left: 2px;
}
.rich-content :deep(img){
    max-width: 100%;
}
.rich-content :deep(table){
    width: 100%;
    border-collapse: collapse;
}

/* 附件 */
.museum-act-file-list{
    margin-top: 8px;
}
.museum-act-file-item{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 16px;
    background-color: #ffffff;
    border-radius: 6px;
    margin-bottom: 10px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.04);
}
.museum-act-file-name{
    font-size: 14px;
    color: #1f2937;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.museum-act-file-actions{
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 12px;
}
.museum-act-file-action{
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.museum-act-file-action img{
    width: 20px;
    height: 20px;
    object-fit: contain;
}
.museum-act-no-file{
    font-size: 14px;
    color: #9ca3af;
    padding: 10px 0;
}

/* 右侧封面 */
.museum-act-cover{
    width: 100%;
    height: 180px;
    margin-top: 8px;
    margin-bottom: 16px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background-color: #f3f4f6;
    border-radius: 6px;
}
.museum-act-cover img{
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}
</style>
